export default __webpack_public_path__ + "static/media/MarkReaded.fbf7146a.svg";